import { useEffect, useState } from 'react';
import { Card, Table, Pagination } from 'react-bootstrap';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ValetPointsList() {
    const [valetPoints, setValetPoints] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [perPage] = useState(10);

    const fetchValetPoints = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/valet-points?page=${currentPage}&per_page=${perPage}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setValetPoints(response.data.data);
            setTotalPages(Math.ceil(response.data.total / response.data.per_page));
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to load valet points');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this valet point?')) return;
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/valet-points/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Valet point deleted successfully');
            fetchValetPoints();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to delete valet point');
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        fetchValetPoints();
    }, [currentPage]);

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 
                    pagetitle="Valet Points List" 
                    righttitle="Add Valet Point" 
                    link="/accounts/valet-points-add" 
                    routebutton={true} 
                    permission='valet-points.create'
                />
                
                <Card className="mb-3">
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Point Name</th>
                                    <th>Location</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {valetPoints.map((point) => (
                                    <tr key={point.id}>
                                        <td>#{point.id}</td>
                                        <td>{point.name}</td>
                                        <td>{point.location_name}</td>
                                        <td>
                                            <span className={`badge ${point.is_active ? 'bg-success' : 'bg-danger'}`}>
                                                {point.is_active ? 'Active' : 'Inactive'}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="btn-group">
                                                <EditButton 
                                                    to={`/accounts/valet-points-edit/${point.id}`} 
                                                    permission='valet-points.edit' 
                                                />
                                                <DeleteButton 
                                                    onDelete={() => handleDelete(point.id)} 
                                                    permission='valet-points.delete' 
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {valetPoints.length === 0 && (
                                    <tr>
                                        <td colSpan="5" className="text-center">No valet points found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First 
                                    onClick={() => handlePageChange(1)} 
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev 
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}
                                />
                                
                                {[...Array(totalPages)].map((_, idx) => (
                                    <Pagination.Item
                                        key={idx + 1}
                                        active={idx + 1 === currentPage}
                                        onClick={() => handlePageChange(idx + 1)}
                                    >
                                        {idx + 1}
                                    </Pagination.Item>
                                ))}
                                
                                <Pagination.Next 
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last 
                                    onClick={() => handlePageChange(totalPages)} 
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default ValetPointsList;
